// extracted by mini-css-extract-plugin
export var ContentWrapper = "style-module--ContentWrapper --fad86";
export var Heading = "style-module--Heading--b7232";
export var Section = "style-module--Section--553c0";